import { logEvent } from "firebase/analytics";
import { analytics } from "../firebaseConfig";
import { H } from "highlight.run";

/**
 * Tracks a single named feature event in both GA4 and Highlight.
 *
 * @param {string} eventName   GA4 event name (snake_case)
 * @param {object} [params]    parameters/metadata to send
 */
export function trackFeature(eventName, params = {}) {
  console.log('[Analytics] trackFeature →', eventName, params);
  // GA4
  if (window.gtag && analytics) {
    logEvent(analytics, eventName, params);
  }
  // Highlight
  if (H && typeof H.log === "function") {
    H.log(eventName, params);
  }
}
